module.exports = __webpack_public_path__ + "static/media/bitcoin3.3e065e41.png";